import { useEffect } from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import CuratedRooms from "@/components/visualiser/CuratedRooms";
import { useSEO, breadcrumb } from "@/lib/useSEO";

// LCP: the first room render Curated Rooms shows on load. Preload so it
// starts fetching before the JS bundle finishes parsing.
const LCP_SRC = "/visualizer/tmb-versailles-parquet-living.jpg";

/**
 * /visualise — thin shell page. BYOR mode is currently hidden (see
 * /components/visualiser/BYOR.jsx). To re-enable, restore the mode tab
 * state and the Suspense-wrapped BYOR block below.
 */
export default function Visualise() {
  useSEO({
    title:
      "Room Visualiser · See Luxury Flooring in Real Rooms — My Floor Studio",
    description:
      "Try any of our timber, stone, tile and carpet finishes on a real room before you specify. Interactive flooring visualiser for architects, designers and homeowners.",
    path: "/visualise",
    keywords:
      "flooring visualiser, room visualiser, flooring preview, timber flooring visualiser, tile visualiser, stone flooring preview, floor colour picker, virtual flooring, interior design tool",
    imageAlt:
      "Room visualiser — try luxury timber, carpet, tile and stone finishes in a real room",
    jsonLd: [
      breadcrumb([
        { name: "Home", path: "/" },
        { name: "Visualise", path: "/visualise" },
      ]),
    ],
  });

  // Preload the LCP image so it starts downloading while React hydrates.
  useEffect(() => {
    const l = document.createElement("link");
    l.rel = "preload"; l.as = "image"; l.href = LCP_SRC; l.fetchPriority = "high";
    document.head.appendChild(l);
    return () => l.parentNode?.removeChild(l);
  }, []);

  return (
    <div className="min-h-[100dvh] bg-[#121315] text-[#F5F4F0]">
      <Nav />

      <header className="px-5 md:px-10 pt-24 md:pt-28 pb-6 md:pb-10 max-w-[1440px] mx-auto">
        <p className="text-[#C9A876] text-[10px] md:text-[11px] tracking-[0.4em] uppercase mb-3">
          The Studio Visualiser
        </p>
        <h1 className="font-serif-display italic text-[#F5F4F0] font-light leading-[0.95] tracking-tight text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
          See it before you spec it.
        </h1>
        <p className="mt-4 md:mt-6 text-[#D6D1CA]/70 text-sm md:text-base max-w-2xl font-body">
          Pick a curated room and swap in any timber, stone, tile or carpet — every
          finish in every colourway, rendered in context.
        </p>
      </header>

      <section className="px-5 md:px-10 pb-16 md:pb-24 max-w-[1440px] mx-auto">
        <CuratedRooms />
      </section>

      <Footer />
    </div>
  );
}
